export const sortSlots = (response, setSlots) => {
  let slots = response.data.reduce((accum, locationData) => {
    let sortedSlots = locationData.slots
      ? Object.entries(locationData.slots)
          .sort((a, b) => a[0].localeCompare(b[0]))
          .reduce((slotsAccum, [date, times]) => {
            if (Array.isArray(times) && times.length > 0) slotsAccum[date] = times;
            return slotsAccum;
          }, {})
      : {};
    accum[locationData.location] = { error: null, slots: sortedSlots };
    return accum;
  }, {});

  setSlots(prevSlots => {
    const updatedSlots = { ...prevSlots };
    Object.keys(slots).forEach(locationCode => {
      updatedSlots[locationCode] = slots[locationCode];
    });
    return updatedSlots;
  });
};
